// LP-1560: when a shipment update left 'sending' may be marked sent or failed by hand. Mirrors
// modules/shipments/messages.js settleable() and SETTLE_AFTER_MIN, so the card shows "Mark as sent"
// and "Mark as failed" only where the API would take them: a message still 'sending' whose send
// started (its updated_at) at least that many minutes ago. The browser's clock decides here and
// the server's decides there; a refused mark still shows its error.
export const SETTLE_AFTER_MIN = 15;

export function canSettle(m, nowMs) {
  const since = Date.parse(m?.updated_at);
  return m?.status === 'sending' && Number.isFinite(since) && nowMs - since >= SETTLE_AFTER_MIN * 60 * 1000;
}
